import Alerts from 'lib/alerts';
import tooltip from 'helpers/tooltip.js';
import template from 'employer/templates/payroll/stepOne/EmployeeSlides.ejs';
import EmployeeView from './Employee.js';
import PayrollDetails from 'newCollections/payroll-details.js';

module.exports = Backbone.View.extend({
    events: {
        'change .js-employee-select': 'selectEmployee',
        'beforeChange .js-employee-slides': 'beforeChangeSlide',
        'afterChange .js-employee-slides': 'afterChangeSlide',
        'click .js-prev-slide': 'prevSlide',
        'click .js-next-slide': 'nextSlide'
    },

    initialize: function(options) {
        this.activeSlideView = null;
        this.nextSlideView = null;
        this.$slides = null;
        this.$prevSlide = null;
        this.$nextSlide = null;
        this.viewedSlides = [];

        this.options = _.defaults(options || {}, {
            employees: null,
            payroll: null,
            payrollDetails: null,
            lastPayrollDetails: null,
            lastPayroll: null,
            pendingJobs: false,
            payrollItems: null
        });
        this.currentEmployee = this.options.employees.first();

        this.render();
    },

    fetchDetails: function(employee = null) {
        const payroll = this.options.payroll;
        const lastPayroll = this.options.lastPayroll;
        let detailsPromise;
        let lastDetailsPromise;

        if (!employee) {
            employee = this.currentEmployee;
        }

        if (!employee) {
            return;
        }

        function detailsForEmployee (details, employee) {
            return details.filterByEmployee(employee.id).length !== 0
        }

        const cachedDetails = detailsForEmployee(
            this.options.payrollDetails, employee
        );

        const cachedLastDetails = detailsForEmployee(
            this.options.lastPayrollDetails, employee
        );

        function fetchDetailsForPayroll(payroll, employee) {
            return new PayrollDetails(null, {payroll}).fetch({
                filter: {
                    limit: 9999,
                    where: {employeeId: employee.id}
                }
            })
                .then(collection => collection.filterNonContributions())
        }

        if (cachedDetails) {
            detailsPromise = Promise.resolve([]);
        } else {
            detailsPromise = payroll.isNew() ?
                PayrollDetails.createDefaults(
                    payroll, [employee]
                ) :
                fetchDetailsForPayroll(payroll, employee);
        }

        if (cachedLastDetails || !lastPayroll) {
            lastDetailsPromise = Promise.resolve([]);
        } else {
            lastDetailsPromise =
                fetchDetailsForPayroll(lastPayroll, employee);
        }

        return Promise.all([
            detailsPromise.then(details => {
                if (details && details.length) {
                    return details;
                }
                if (!cachedDetails) {
                    return PayrollDetails
                        .createDefaults(payroll, [employee]);
                }
                return [];
            }).then(collection => {
                // Do not append if already cached
                if (!cachedDetails && collection.length > 0) {
                    collection.models.forEach(detail => {
                        this.options.payrollDetails.add(detail);
                    });
                }
            }),
            lastDetailsPromise.then(collection => {
                // Do not append if already cached
                if (!cachedLastDetails && collection.length > 0) {
                    collection.models.forEach(detail => {
                        this.options.lastPayrollDetails.add(detail);
                    });
                }
            })
        ]);
    },

    render: function() {
        this.$el.html(template({
            currentEmployee: this.currentEmployee,
            employees: this.options.employees
        }));

        this.$slides = this.$('.js-employee-slides');
        this.$prevSlide = this.$('.js-prev-slide');
        this.$nextSlide = this.$('.js-next-slide');
        this.$employeeSelect = this.$('.js-employee-select');

        this.$slides.slick({
            slidesToShow: 1,
            swipe: false,
            infinite: false,
            arrows: false,
            draggable: false,
            touchMove: false,
            accesibility: false
        });

        tooltip.init(this);
    },

    renderSlide: function(employee) {
        var view = new EmployeeView({
            model: employee,
            payroll: this.options.payroll,
            pendingJobs: this.options.pendingJobs,
            payrollDetails: this.options.payrollDetails,
            lastPayrollDetails: this.options.lastPayrollDetails,
            payrollItems: this.options.payrollItems,
            className: 'employee footable-employee js-is-card'
        });
        this.$('.js-slide-' + employee.id).append(view.$el);
        return view;
    },

    renderCount: function(current) {
        const total = this.options.employees.length;
        const progress = Math.round(100 * (current / total));
        let text = ' of ' + total + ' ';
        text += (total === 1) ? 'Employee' : 'Employees';
        this.$('.js-employee-counter').text('')
            .append($('<strong>').text(current))
            .append(text);
        this.$('.js-progress-bar').css('width', progress + '%');
    },

    prevSlide: function() {
        this.$prevSlide.tooltip('hide').addClass('loading');
        this.activeSlideView.lock();
        this.save()
            .then(() => {
                const employee = this.options.employees.at(
                    Math.max(0, this.$slides.slick('slickCurrentSlide') - 1)
                );
                return this.fetchDetails(employee);
            })
            .then(() => this.$slides.slick('slickPrev'))
            .finally(() => this.$prevSlide.removeClass('loading'));
    },

    nextSlide: function() {
        this.$nextSlide.tooltip('hide').addClass('loading');
        this.activeSlideView.lock();
        this.save()
            .then(() => {
                const employee = this.options.employees.at(
                    Math.max(0, this.$slides.slick('slickCurrentSlide') + 1)
                );
                return this.fetchDetails(employee);
            })
            .then(() => this.$slides.slick('slickNext'))
            .finally(() => this.$nextSlide.removeClass('loading'));
    },

    selectEmployee: function(ev) {
        const $input = $(ev.currentTarget);

        ev.preventDefault();

        const search = $input.val();
        const matchingEmployee = this.options.employees
            .find(
                emp => (
                    emp.get('employeeId') && emp.get('employeeId') === search
                ) || emp.get('fullName') === search
            );
        if (!matchingEmployee) {
            return;
        }
        const matchingIndex = this.options.employees
            .findIndex(emp =>
                emp.get('objectId') === matchingEmployee.get('objectId')
            );
        this.currentEmployee = matchingEmployee;

        const currentSlide = this.$slides.slick('slickCurrentSlide');
        const $button      = currentSlide < matchingIndex ?
            this.$nextSlide : this.$prevSlide;

        $button.addClass('loading');
        this.activeSlideView.lock();

        $input.val('');

        this.save()
            .then(() => this.fetchDetails(this.currentEmployee))
            .then(() => this.$slides.slick('slickGoTo', matchingIndex))
            .finally(() => {
                $button.removeClass('loading');
            });
    },

    save: function($el) {
        if ($el) {
            $el.addClass('loading');
        }

        this.$prevSlide.addClass('slick-disabled');
        this.$nextSlide.addClass('slick-disabled');
        this.$employeeSelect
            .prop({disabled: true})
            .attr({disabled: true})
            .trigger('chosen:updated');

        const save = (
            !this.options.payroll.get('running') &&
            !this.options.pendingJobs
        );
        const promise = save ?
            this.options.payroll.save(null, {validate: false}) :
            Promise.resolve();

        return promise
            .then(() => {
                return save ?
                    this.options.payrollDetails.save() :
                    Promise.resolve();
            })
            .catch(err => { Alerts.show('criticalError', err); })
            .finally(() => {
                if ($el) {
                    $el.removeClass('loading');
                }

                this.$prevSlide.addClass('slick-disabled');
                this.$nextSlide.addClass('slick-disabled');
                this.$employeeSelect
                    .prop({disabled: false})
                    .attr({disabled: false})
                    .trigger('chosen:updated');
            });
    },

    beforeChangeSlide: function(event, slick, currentSlide, nextSlide) {
        this.nextSlideView = this.renderSlide(
            this.options.employees.at(nextSlide)
        );
        this.nextSlideView.$el.removeClass('invisible').trigger('show');

        this.toggleSlideButtons(nextSlide + 1);
        this.renderCount(nextSlide + 1);
    },

    afterChangeSlide: function() {
        var prevSlideView = this.activeSlideView;

        this.viewedSlides = _.uniq(this.viewedSlides.concat([
            this.$slides.slick('slickCurrentSlide')
        ]));

        this.activeSlideView = this.nextSlideView;

        prevSlideView.remove();
    },

    toggleSlideButtons: function(slide) {
        this.$prevSlide.toggleClass('slick-disabled', (slide === 1));
        this.$nextSlide.toggleClass(
            'slick-disabled', (slide === this.options.employees.length)
        );
    },

    activate: function() {
        if (this.activeSlideView !== null) {
            return;
        }

        const employee = this.currentEmployee || this.options.employees.first();
        this.fetchDetails(employee)
            .then(() => {
                this.activeSlideView = this.renderSlide(employee);
                this.activeSlideView.$el
                    .removeClass('invisible')
                    .trigger('show');

                this.viewedSlides.push(0);
                this.toggleSlideButtons(1);
                this.renderCount(1);

                setTimeout(() => {
                    this.$slides
                        .slick('setPosition')
                        .removeClass('invisible');
                }, 1);
            });
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);

        this.undelegateEvents();
        if (this.activeSlideView) {
            this.activeSlideView.remove();
        }

        if (this.nextSlideView) {
            this.nextSlideView.remove();
        }
    },

    confirmMissingEmployees: function() {
        // By default include all employees to the payroll
        return Promise.resolve(true);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepOne/EmployeeSlides.js